import { render } from "./ClientIPMI.vue?vue&type=template&id=2292c2e0&scoped=true"
import script from "./ClientIPMI.vue?vue&type=script&lang=js"
export * from "./ClientIPMI.vue?vue&type=script&lang=js"

import "./ClientIPMI.vue?vue&type=style&index=0&id=2292c2e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2292c2e0"]])

export default __exports__